import PropTypes from 'prop-types'
import React from 'react'
import { TextButton } from './TextButton'
import EditIcon from '../../atoms/icons/EditIcon'
import CloseIcon from '../../atoms/icons/Close'

const EditCancelButton = ({ onClick, editMode, className }) => {
  return (
    <TextButton
      onClick={onClick}
      startIcon={editMode ? null : <EditIcon className="w-5" />}
      endIcon={editMode ? <CloseIcon className="w-5" /> : null}
      className={className}
    >
      {editMode ? 'Cancelar' : 'Editar'}
    </TextButton>
  )
}

export default EditCancelButton

EditCancelButton.propTypes = {
  onClick: PropTypes.func,
  editMode: PropTypes.bool,
  className: PropTypes.string
}
